import { render, staticRenderFns } from "./debtsPage.vue?vue&type=template&id=c278c8c0&scoped=true&"
import script from "./debtsPage.vue?vue&type=script&lang=ts&"
export * from "./debtsPage.vue?vue&type=script&lang=ts&"
import style0 from "./debtsPage.vue?vue&type=style&index=0&id=c278c8c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c278c8c0",
  null
  
)

export default component.exports